module.exports = __webpack_public_path__ + "static/media/icon-imagery-scores.2160883b.svg";